export default "__VITE_ASSET__CavrE8BW__"